import { FormattedMessage } from "react-intl";
import { useState, useEffect } from "react";
import DateTimePicker from "react-datetime-picker";
import { useDispatch, useSelector } from "react-redux";
import { Col } from "reactstrap";
import { updatePropertyById } from "../../../utils/layout";

import * as actionTypes from "../../../store/Actions/actions";
import SideMargin from "./SideMargins";
import Popup from "../../Modal/Popup";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";

import "./Timer.scss";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

const SelectOption = ({ name, valuesList, value, onChange }) => {
  return (
    <>
      <label>{name}</label>
      <div>
        <select
          onChange={onChange}
          value={value}
        >
          {valuesList.map((opt, i) => <option key={i} value={opt.value}>{opt.text}</option>)}
        </select>
      </div>
    </>
  )
}

const StyleOption = ({ name, isActive, onClick }) => {
  return (
    <div className={`${isActive === name ? "active" : ""}`}>
      <ul className={name} onClick={() => onClick(name)}>
        <li>
          <span>00</span>
          <p><FormattedMessage id="timer.days" defaultMessage={"days"} /></p>
        </li>
        <li>
          <span>00</span>
          <p><FormattedMessage id="timer.hours" defaultMessage={"hours"} /></p>
        </li><li>
          <span>00</span>
          <p><FormattedMessage id="timer.minutes" defaultMessage={"minutes"} /></p>
        </li><li>
          <span>00</span>
          <p><FormattedMessage id="timer.seconds" defaultMessage={"seconds"} /></p>
        </li>
      </ul>
    </div>
  )
}

const styles = ["whiteBox--timer", "whiteRound--timer", "blackBox--timer", "blackRound--timer", "whiteRoundBorder--timer", "blackBoxBorder--timer"]

const TimerModal = (props) => {
  const { layout, layoutTitle } = useSelector(state => state.present);
  const dispatch = useDispatch();

  const [label, setLabel] = useState("")
  const [date, setDate] = useState("")
  const [float, setFloat] = useState("")
  const [size, setSize] = useState("")
  const [patternStyle, setPatternStyle] = useState("")
  const [timerMarginUnit, setTimerMarginUnit] = useState("")

  useEffect(() => {
    setLabel(props.label)
    setDate(props.date)
    setFloat(props.float)
    setSize(props.size)
    setPatternStyle(props.patternStyle)
    setTimerMarginUnit(props.timerMarginUnit)
  }, [])

  const updateLayoutItem = (property, value) => {
    const layoutCopy = JSON.parse(JSON.stringify(layout));
    const newITEM = updatePropertyById(layoutCopy, props.ID, property, value);
    dispatch(actionTypes.layout({ titleLayout: layoutTitle, layout: newITEM }));
  };

  const addTimerLabel = (e) => {
    const value = e.target.value;
    setLabel(value);
    updateLayoutItem('label', value);
  };

  const onChangeTimer = (d) => {
    const newDate = new Date();
    const date = d || newDate;
    setDate(d);
    updateLayoutItem('date', date);
  };

  const alignChangeTimer = (e) => {
    const float = e.target.value;
    setFloat(float);
    updateLayoutItem('style', { float });
  };

  const alignSizeTimer = (e) => {
    const size = e.target.value;
    setSize(size);
    updateLayoutItem('size', size);
  };

  const handlePatternStyle = (pattern) => {
    setPatternStyle(pattern);
    updateLayoutItem('patternStyle', pattern);
  };

  const unitValueChange = (e) => {
    const value = e.target.value;
    setTimerMarginUnit(value);
    updateLayoutItem('style', { timerMarginUnit: value });
  };

  return (
    <Popup
      width="700"
      header="Countdown Timer"
      closePopup={props.hideTimer}
      close={props.hideTimer}
      parentID="templateWrap"
    >
      <div className="timerModalMain modalScrollContainerSecondary">
        <div className="timerModal">
          <div className="">
            <div className="timerOptionsWrapper">
              <label>
                Timer Label <small> (For Meta Data and Aria Labels)</small>
              </label>
              <input
                onChange={addTimerLabel}
                defaultValue={label}
                placeholder="Add Timer Label"
                className="imageLabelInput"
              />
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div >
                  <label>Enter Date for Countdown</label>
                  <div className="dateWrapper">
                    <DateTimePicker onChange={onChangeTimer} value={date} />
                  </div>
                </div>
                <Col sm="3">
                  <SelectOption
                    name="Position"
                    onChange={alignChangeTimer}
                    value={float}
                    valuesList={[
                      { value: "left", text: "Left" },
                      { value: "none", text: "Center" },
                      { value: "right", text: "Right" }
                    ]}
                  />
                </Col>
                <Col sm="3">
                  <SelectOption
                    name="Size"
                    onChange={alignSizeTimer}
                    value={size}
                    valuesList={[
                      { value: "smaller", text: "Smaller" },
                      { value: "medium", text: "Medium" },
                      { value: "large", text: "Large" }
                    ]}
                  />
                </Col>
              </div>
            </div>
            <div style={{ marginTop: "30px", marginBottom: "5px" }} className="padding-section">
              <div className="heading">Styles</div>
            </div>
            <div className="timerStylesWrapper">
              {styles.map((style, i) => <StyleOption key={i} isActive={patternStyle} name={style} onClick={handlePatternStyle} />)}
            </div>
            <div style={{ marginTop: "30px", marginBottom: "5px" }} className="padding-section">
              <div className="heading">Margin</div>
            </div>
            <div className="marginTimer">
              <div className="heading-row" style={{ justifyContent: "flex-end" }}>
                <UnitSelector
                  value={timerMarginUnit}
                  onChange={(e) => { unitValueChange(e) }}
                />
              </div>
              <SideMargin
                ID={props.ID}
                margin={props.margin}
                timerMarginUnit={timerMarginUnit}
                marginTop={props.marginTop}
                marginRight={props.marginRight}
                marginBottom={props.marginBottom}
                marginLeft={props.marginLeft}
              />
            </div>
            <div style={{ marginBottom: "20px" }} className="clearboth"></div>
          </div>
        </div>
      </div>
    </Popup>
  );
}
export default TimerModal;
